import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("propFYxqmVcufMhk5esNMrexq2ogHbbC2kP9PU1qxKs");
//# sourceMappingURL=constants.js.map